import React from 'react';

const ErrorText = ({ error }: { error: string }) => {
    return (
        <div style={{ fontSize: 15, color: "red" }}>
            {error}
        </div>
    );
};

export default ErrorText;